export default "__VITE_ASSET__CVBi3TGu__"